module.exports = __webpack_public_path__ + "img/dale-pro.85a6baec.jpg";